import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import aiCreateService, { useAICreateProjects } from "api/aiCreateService";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentOrganizationId } from "store/features/session/slice";
import { addAlert } from "store/features/general/slice";
import { useTranslation } from "react-i18next";

const AICreateDeleteProjectDialog: React.FC<{
  projectId?: number;
  close: () => void;
}> = ({ projectId, close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const currentOrganizationId = useSelector(selectCurrentOrganizationId);
  const { removeCachedAICreateProject } = useAICreateProjects(
    currentOrganizationId
  );

  const deleteProject = () => {
    if (projectId) {
      setLoading(true);
      aiCreateService
        .deleteAICreateProject(projectId)
        .then(() => {
          close();
          removeCachedAICreateProject(projectId);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          close();
          dispatch(
            addAlert({
              severity: "error",
              autoHideDuration: 5000,
              alert: {
                message: t("something_went_wrong_please"),
              },
            })
          );
        });
    }
  };

  return (
    <Dialog open={!!projectId} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>
        {t("delete_project")}
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{t("are_you_certain_delete_project")}</DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" size="medium" onClick={close}>
          {t("cancel")}
        </Button>
        <LoadingButton
          onClick={deleteProject}
          color="primary"
          size="medium"
          variant="contained"
          loading={loading}
        >
          {t("delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AICreateDeleteProjectDialog;
